<div id="wrapper" class="mat-typography">
  <div id="circle"><mat-icon>check</mat-icon></div>
  <div id="right">
    <b i18n="@@successModalHeader">Success!</b>
    <span i18n="@@successModalGuidance">Please wait to be called.</span>
  </div>
</div>
